import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=114dc0b4&scoped=true&"
import script from "../../../services/applicant/job_listing/company-detail.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/job_listing/company-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_details.css?vue&type=style&index=0&id=114dc0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114dc0b4",
  null
  
)

export default component.exports